import { Engine1Proxy, ConciergeProxy, RestApiProxy, SagasHelper } from 'com-gyf-webcore-servicehub';
import { LogHelper } from 'com-gyf-webcore-loghelper';
import ProcessManager from '../../../Common/Managers/ProcessManager';
import ConfiguracionProcesosManager from '../../../Common/Managers/ConfiguracionProcesosManager';

//Seteo de apiUrl
RestApiProxy.SetApiUrl();

export const GET_DATOS_EDITAR_CONFIGURACION_PROCESO_DATA = 'GET_DATOS_EDITAR_CONFIGURACION_PROCESO_DATA';
export const GET_DATOS_EDITAR_CONFIGURACION_PROCESO_DATA_RESULT = 'GET_DATOS_EDITAR_CONFIGURACION_PROCESO_DATA_RESULT';
export const SET_USER_FUNCTIONS = 'SET_USER_FUNCTIONS';
export const SELECT_RADIO_PROCESO = 'SELECT_RADIO_PROCESO';
export const CHANGE_INPUT_PROCESO = 'CHANGE_INPUT_PROCESO';
export const SET_CHECK = 'SET_CHECK';
export const SELECT_COMBO_PROCESO = 'SELECT_COMBO_PROCESO';
export const VALIDATE_PROCESS = 'VALIDATE_PROCESS';
export const ROUTE_TO_EDITAR_CONFIGURACION_PROCESO = 'ROUTE_TO_EDITAR_CONFIGURACION_PROCESO';
export const READY_REQUEST_PROCESS = 'READY_REQUEST_PROCESS';
export const INITIAL_STATE = 'INITIAL_STATE';
export const GET_DATOS_CARTERAS = 'GET_DATOS_CARTERAS';
export const SHOW_SAVE_STATUS_PROCESO = 'SHOW_SAVE_STATUS_PROCESO';
export const CHECK_ARCHIVO_ASOCIADO = 'CHECK_ARCHIVO_ASOCIADO';
export const SET_LABEL_NOMBRE_ARCHIVO = 'SET_LABEL_NOMBRE_ARCHIVO';
export const SET_OPTION_NOMBRE_ARCHIVO = 'SET_OPTION_NOMBRE_ARCHIVO';
export const SET_RADIO_BUTTON_ARCHIVO = 'SET_RADIO_BUTTON_ARCHIVO';
export const SET_NOMBRE_ARCHIVO = 'SET_NOMBRE_ARCHIVO';
export const SET_NOMBRE_ARCHIVO_FINAL = 'SET_NOMBRE_ARCHIVO_FINAL';
export const SET_OPTION_FORMATO_FECHA_HORA = 'SET_OPTION_FORMATO_FECHA_HORA';
export const SET_DESCRIPCION_FORMATO_FECHA_HORA = 'SET_DESCRIPCION_FORMATO_FECHA_HORA';
export const SET_CAMPO_DESCRIPCION = 'SET_CAMPO_DESCRIPCION';
export const SET_VARIABLES_NOMBRE_ARCHIVO_FINAL = 'SET_VARIABLES_NOMBRE_ARCHIVO_FINAL';
export const VALIDAR_RDBUTTON = 'VALIDAR_RDBUTTON';
export const ERROR_NOMBRE_ARCHIVO = 'ERROR_NOMBRE_ARCHIVO';
export const ERROR_FORMATO_FECHA_HORA = 'ERROR_FORMATO_FECHA_HORA';
export const ERROR_FORMATO_NOMBRE_ARCHIVO = 'ERROR_FORMATO_NOMBRE_ARCHIVO';


let _dispatch;
let _userFunctions;
let _idProceso;
let formatoOrdenNombreArchivo;
let stateGlobal;
let _getState;
/**
 *
 * @param {any} id
 * @param {any} currentScope
 * @param {any} cuenta
 */
export function getScreenData(state, currentScope) {
    LogHelper.In(getScreenData.name, currentScope);

    _idProceso = JSON.parse(state);

    return (dispatch, getState) => {
        stateGlobal = getState();
        
        _dispatch = dispatch;
        _getState = getState;

        dispatch({ type: GET_DATOS_EDITAR_CONFIGURACION_PROCESO_DATA });

        var currentScopeRequest = {
            UserId: currentScope.UserId,
            ProductCode: currentScope.ProductCode,
            ProgramCode: currentScope.ProgramCode,
        };

        ConciergeProxy.Execute((data) => _loadScreenData(data), null, 'GETFUNCTIONS', currentScopeRequest);
    };
}

/**
 *
 * @param {any} list
 * @param {any} item
 */
export function selectRadio(list, item, params) {
    LogHelper.In(selectRadio.name, list, item, params);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        //dispatch({ type: SELECT_RADIO_PROCESO, payload:{ list, item, params} });
        dispatch({ type: SELECT_RADIO_PROCESO, list: list, item: item, params });
    };
}

/**
 *
 * @param {any} action
 * @param {any} value
 */
export function changeInput(action, value) {
    LogHelper.In(changeInput.name, action, value);

    return (dispatch) => {
        dispatch({ type: CHANGE_INPUT_PROCESO, action: action, value: value });
    };
}

export function setCheck(name, value) {
    LogHelper.In(setCheck.name, value);
    return (dispatch, getState) => {
        dispatch({ type: SET_CHECK, name, value });
    };
}

export function seleccionarCombo(valor, combo, ...params) {
    LogHelper.In(seleccionarCombo.name, valor, combo);

    return (dispatch, getState) => {
        let validarPantalla = false;
        dispatch({ type: SELECT_COMBO_PROCESO, valor, combo, params, validarPantalla });
    };
}

export function validateAddProcess(data, form) {
    LogHelper.In(validateAddProcess.name, data, form);
    
    return (dispatch, getState) => {
        let hayError = false;
        let hayErrorValidacion = false;

        //Se quita el valor por default del RdButton de separación del archivo en el caso de que ambos checkboxes (fecha y hora) estén destildados
        _dispatch({ type: VALIDAR_RDBUTTON,  checkFecha: data?.archivoAsociado?.checkFecha, checkHora: data?.archivoAsociado?.checkHora});

        stateGlobal = getState();

        let stateArchivoAsociado = stateGlobal?.editarConfiguracionProceso?.archivoAsociado ? stateGlobal.editarConfiguracionProceso.archivoAsociado : null;
        let formatoArchivo = stateArchivoAsociado.formatoOrdenArchivoCombo && stateArchivoAsociado.formatoOrdenArchivoCombo > 0 ? parseInt(stateArchivoAsociado.formatoOrdenArchivoCombo) : null;

        if (stateArchivoAsociado.nombreArchivoUsuario == "") {
            hayError = true;
            _dispatch({ type: ERROR_NOMBRE_ARCHIVO, valor: hayError});
        }

        if (data?.archivoAsociado?.checkFecha) {
            hayErrorValidacion = data?.archivoAsociado?.optionSeleccionadaFecha == "0";
            hayError = hayErrorValidacion ? hayErrorValidacion : hayError;

            _dispatch({ type: ERROR_FORMATO_FECHA_HORA,  campo: "errorComboFecha", valor: hayErrorValidacion})
        }

        if (data?.archivoAsociado?.checkHora) {
            hayErrorValidacion = data?.archivoAsociado?.optionSeleccionadaHora == "0";
            hayError = hayErrorValidacion ? hayErrorValidacion : hayError;

            _dispatch({ type: ERROR_FORMATO_FECHA_HORA,  campo: "errorComboHora", valor: hayErrorValidacion});
        }

        if (data?.archivoAsociado?.checkFecha || data?.archivoAsociado?.checkHora) {
            hayErrorValidacion = data?.archivoAsociado?.formatoOrdenArchivoCombo == "0";
            hayError = hayErrorValidacion ? hayErrorValidacion : hayError;

            _dispatch({ type: ERROR_FORMATO_NOMBRE_ARCHIVO, valor: hayErrorValidacion});
        }

        if (!hayError) {
            _dispatch({ type: ERROR_NOMBRE_ARCHIVO, valor: hayError});
            _dispatch({ type: ERROR_FORMATO_FECHA_HORA, campo: "errorComboFecha", valor: hayError});
            _dispatch({ type: ERROR_FORMATO_FECHA_HORA, campo: "errorComboHora", valor: hayError});
            _dispatch({ type: ERROR_FORMATO_NOMBRE_ARCHIVO, valor: hayError});
            
            let dataNombreArchivo = {
                ArchivoAsociado: stateArchivoAsociado.nombreArchivoUsuario,
                FormatoFechaArchivoId: stateArchivoAsociado.optionSeleccionadaFecha && stateArchivoAsociado.optionSeleccionadaFecha > 0 ? parseInt(stateArchivoAsociado.optionSeleccionadaFecha) : null,
                FormatoHoraArchivoId: stateArchivoAsociado.optionSeleccionadaHora && stateArchivoAsociado.optionSeleccionadaHora > 0 ? parseInt(stateArchivoAsociado.optionSeleccionadaHora) : null,
                FormatoNombreArchivoId: formatoArchivo,
                TipoSeparacionArchivo: formatoArchivo ? stateArchivoAsociado.idRBFormato : null
            }

            _dispatch({ type: SET_VARIABLES_NOMBRE_ARCHIVO_FINAL, dataNombreArchivo});

            stateGlobal = getState();
            _loadValidateAddProcess(stateGlobal?.editarConfiguracionProceso, form);
        }
    };
}

export function cancelProcess(dispatch) {
    LogHelper.In(cancelProcess.name, dispatch);

    return (dispatch) => {
        _dispatch = dispatch;
        _routing(null, ROUTE_TO_EDITAR_CONFIGURACION_PROCESO, dispatch);
    };
}

export function resetState() {
    LogHelper.In(resetState.name);

    return (dispatch) => {
        dispatch({ type: INITIAL_STATE });
    };
}

export function finishProcess() {
    LogHelper.In(finishProcess.name);

    return (dispatch) => {
        $('.modal').modal('hide');
        _dispatch = dispatch;
        _routing(null, ROUTE_TO_EDITAR_CONFIGURACION_PROCESO, _dispatch);
    };
}

export function checkArchivosAsociados(campo, valor) {
    LogHelper.In(checkArchivosAsociados.name);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        _dispatch({ type: CHECK_ARCHIVO_ASOCIADO, campo, valor });
        const stateArchivoAsociado = getState().editarConfiguracionProceso.archivoAsociado;
        let labelNombreArchivo = setLabelNombreArchivo(stateArchivoAsociado.checkFecha, stateArchivoAsociado.checkHora);
        let optionNombreArchivo = setComboNombreArchivo(stateArchivoAsociado.checkFecha, stateArchivoAsociado.checkHora, formatoOrdenNombreArchivo);
        _dispatch({ type: SET_LABEL_NOMBRE_ARCHIVO, labelNombreArchivo });
        _dispatch({ type: SET_OPTION_NOMBRE_ARCHIVO, optionNombreArchivo });
        _dispatch({ type: SET_OPTION_FORMATO_FECHA_HORA, campo: "formatoOrdenArchivoCombo", valor: "0" });
        _dispatch({ type: SET_DESCRIPCION_FORMATO_FECHA_HORA, campo: "descOrdenNombreArchivo", valor: "" });

        stateGlobal = getState();

        _dispatch({ type: VALIDAR_RDBUTTON,  checkFecha: stateGlobal?.archivoAsociado?.checkFecha, checkHora: stateGlobal?.archivoAsociado?.checkHora});

        stateGlobal = getState();

        setNombreFinalArchivo(false);
    };
}

export function setRadioButton(valor) {
    LogHelper.In(setRadioButton.name);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        _dispatch({ type: SET_RADIO_BUTTON_ARCHIVO, valor });
        stateGlobal = getState();
        setNombreFinalArchivo(true, valor);
    };
}

export function setNombreArchivo(valor) {
    LogHelper.In(setNombreArchivo.name);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        _dispatch({ type: SET_NOMBRE_ARCHIVO, valor });
        stateGlobal = getState();
        setNombreFinalArchivo(false);
    };
}

export function setOptionFormatoArchivo(valor, campo, codigo, texto) {
    LogHelper.In(setOptionFormatoArchivo.name);

    return (dispatch, getState) => {
        let campoDescripcion = getCampoDescripcion(campo);
        _dispatch = dispatch;
        _dispatch({ type: SET_CAMPO_DESCRIPCION, campoDescripcion, valor: texto })
        _dispatch({ type: SET_OPTION_FORMATO_FECHA_HORA, campo, valor });
        stateGlobal = getState();
        if (valor == "0")
            _dispatch({ type: SET_NOMBRE_ARCHIVO_FINAL, valor: "" });
        else
            setNombreFinalArchivo(false);
    };
}
/***************************************************************************************************************************************************************
 *************************************************************************************************************************************************************** */

function getCampoDescripcion(campo) {
    let campoDesc = null;

    switch (campo) {
        case "optionSeleccionadaFecha":
            campoDesc = "descFormatoFechaUsuario"
            break;
        case "optionSeleccionadaHora":
            campoDesc = "descFormatoHoraUsuario"
            break;
        case "formatoOrdenArchivoCombo":
            campoDesc = "descOrdenNombreArchivo"
            break;
        default:
            campoDesc = null
            break;
    }

    return campoDesc;
}

function _loadScreenData(data) {
    let funcionesDelUsuario = JSON.parse(JSON.stringify(data.PROCESOS));
    let inhabilitarModificarConfig = true;

    funcionesDelUsuario.forEach((p) => {
        if (p.Codigo_Funcion == 'Modificacion') inhabilitarModificarConfig = false;
    });

    let param = { ProcesoId: _idProceso };

    Engine1Proxy.AddDataSourcesRequests(param, 'GET_PROCESO_DATOS', 'Get', 'Tarjetas', 'PROCESOS', null, 'User', true);
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_SSIS_FORMATO_NOMBRE_ARCHIVO', 'Get', 'Tarjetas', 'PROCESOS', 1, 'User', true);
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_FORMATO_FECHA_HORA', 'Get', 'Tarjetas', 'PROCESOS', 1, 'User', true);

    Engine1Proxy.Execute((data) => _loadProcesosData(data), null, null, 'PROCESOS');

    _dispatch({ type: SET_USER_FUNCTIONS, _userFunctions, inhabilitarModificarConfig });
    _dispatch({ type: GET_DATOS_EDITAR_CONFIGURACION_PROCESO_DATA });
}

function _loadProcesosData(data) {
    LogHelper.In(_loadProcesosData.name, data);

    let result = {
        calendario: JSON.parse(data.GET_PROCESO_DATOS).Recordset0.Rows[0],
        proceso: JSON.parse(data.GET_PROCESO_DATOS).Recordset1.Rows[0],
        optionFormatoFecha: JSON.parse(data.GET_FORMATO_FECHA_HORA).Recordset0.Rows,
        optionFormatoHora: JSON.parse(data.GET_FORMATO_FECHA_HORA).Recordset1.Rows
    };
    let paramCartera = { ADMINISTRADORA_ID: result.proceso.AdministradoraId };
    formatoOrdenNombreArchivo = JSON.parse(data.GET_SSIS_FORMATO_NOMBRE_ARCHIVO);

    //Valido si hay que checkear el check de fecha y/o hora
    let formatoFechaActivo = result?.proceso && result.proceso.FormatoFechaArchivoId ? true : false;
    let formatoHoraActivo = result?.proceso && result.proceso.FormatoHoraArchivoId ? true : false;

    //Valido si hay alguna opción seleccionada de Formato Fecha o Hora
    let optionSeleccionadaFecha = formatoFechaActivo ? result.proceso.FormatoFechaArchivoId : "0";
    let optionSeleccionadaHora = formatoHoraActivo ? result.proceso.FormatoHoraArchivoId : "0";
    //Nombre del archivo guardado por el usuario
    let nombreArchivo = result?.proceso?.ArchivoAsociado ? result.proceso.ArchivoAsociado : "";
    //Obtengo la descripción del formato de fecha
    let descFormatoFecha = result?.optionFormatoFecha.find(x => x.Id == optionSeleccionadaFecha)?.Descripcion ?
        result?.optionFormatoFecha.find(x => x.Id == optionSeleccionadaFecha)?.Descripcion : "";
    //Obtengo la descripción del formato de hora
    let descFormatoHora = result?.optionFormatoHora.find(x => x.Id == optionSeleccionadaHora)?.Descripcion ?
        result?.optionFormatoHora.find(x => x.Id == optionSeleccionadaHora)?.Descripcion : "";
    //Obtengo la opción seleccionada en el orden para el formato del archivo
    let FormatoNombreArchivoId = result?.proceso?.FormatoNombreArchivoId ? result?.proceso?.FormatoNombreArchivoId : null;
    let descOrdenNombreArchivo = FormatoNombreArchivoId ?
        formatoOrdenNombreArchivo?.Recordset3?.Rows.find(formato => formato.Id == FormatoNombreArchivoId)?.Descripcion ?
            formatoOrdenNombreArchivo?.Recordset3.Rows.find(formato => formato.Id == FormatoNombreArchivoId)?.Descripcion : "" : "";

    let labelNombreArchivo = setLabelNombreArchivo(formatoFechaActivo, formatoHoraActivo);
    let optionNombreArchivo = setComboNombreArchivo(formatoFechaActivo, formatoHoraActivo, formatoOrdenNombreArchivo);

    Engine1Proxy.AddDataSourcesRequests(paramCartera, 'GET_CARTERAS', 'Get', 'Tarjetas', 'PARAMETRIA', null, 'User', true);
    Engine1Proxy.Execute((data) => _loadCarterasData(data), null, null, 'CONSULTASOCIOS');

    //Realizo dispatch
    _dispatch({ type: GET_DATOS_EDITAR_CONFIGURACION_PROCESO_DATA_RESULT, result: result });
    //true o false para los check de formato fecha y hora
    _dispatch({ type: CHECK_ARCHIVO_ASOCIADO, campo: "checkFecha", valor: formatoFechaActivo });
    _dispatch({ type: CHECK_ARCHIVO_ASOCIADO, campo: "checkHora", valor: formatoHoraActivo });
    //Guardo el nombre del archivo obtenido de la BD
    _dispatch({ type: SET_NOMBRE_ARCHIVO, valor: nombreArchivo });
    //Guardo la descripción para el formato de fecha y hora
    _dispatch({ type: SET_DESCRIPCION_FORMATO_FECHA_HORA, campo: "descFormatoFecha", valor: descFormatoFecha });
    _dispatch({ type: SET_DESCRIPCION_FORMATO_FECHA_HORA, campo: "descFormatoHora", valor: descFormatoHora });
    //Guardo la descripción y ID del orden para el formato del archivo
    let id = FormatoNombreArchivoId ? FormatoNombreArchivoId : "0";
    _dispatch({ type: SET_OPTION_FORMATO_FECHA_HORA, campo: "formatoOrdenArchivoCombo", valor: id });
    _dispatch({ type: SET_DESCRIPCION_FORMATO_FECHA_HORA, campo: "descOrdenNombreArchivo", valor: descOrdenNombreArchivo });
    //Guardo los options para el combo de formato fecha y hora
    _dispatch({ type: SET_OPTION_FORMATO_FECHA_HORA, campo: "optionSeleccionadaFecha", valor: optionSeleccionadaFecha });
    _dispatch({ type: SET_CAMPO_DESCRIPCION, campoDescripcion: "descFormatoFechaUsuario", valor: descFormatoFecha })

    _dispatch({ type: SET_OPTION_FORMATO_FECHA_HORA, campo: "optionSeleccionadaHora", valor: optionSeleccionadaHora });
    _dispatch({ type: SET_CAMPO_DESCRIPCION, campoDescripcion: "descFormatoHoraUsuario", valor: descFormatoHora })
    
    //Guardo el nombre del label para el combo de orden de formato de archivo
    _dispatch({ type: SET_LABEL_NOMBRE_ARCHIVO, labelNombreArchivo });
    //Guardo las options para el orden de nombre del archivo
    _dispatch({ type: SET_OPTION_NOMBRE_ARCHIVO, optionNombreArchivo });
    //Guardo las options para el orden de nombre del archivo
    _dispatch({ type: SET_RADIO_BUTTON_ARCHIVO, valor: result?.proceso?.TipoSeparacionArchivo });

    stateGlobal = _getState();

    let getArchivoAsociado = _getState().editarConfiguracionProceso?.archivoAsociado

    setNombreFinalArchivo(getArchivoAsociado?.idRBFormato, getArchivoAsociado?.idRBFormato)
}


function setNombreFinalArchivo(actionRdButton, idRB) {
    let stateArchivoAsociado =  stateGlobal?.editarConfiguracionProceso?.archivoAsociado ? stateGlobal.editarConfiguracionProceso.archivoAsociado : null;
    let ordenFormatoArchivo, formatoGuion, nombreFinal = "";

    if (stateArchivoAsociado) {
        ordenFormatoArchivo = stateArchivoAsociado?.descOrdenNombreArchivo ? stateArchivoAsociado.descOrdenNombreArchivo.toString() : "";

        if (actionRdButton && idRB) {
            switch (idRB) {
                case 1:
                    formatoGuion = replaceFechaHoraNombreArchivo(ordenFormatoArchivo, stateArchivoAsociado);
                    nombreFinal = formatoGuion;
                    break;
                case 2:
                    formatoGuion = replaceFechaHoraNombreArchivo(ordenFormatoArchivo, stateArchivoAsociado, true);
                    nombreFinal = formatoGuion;
                    break;
                case 3:
                    ordenFormatoArchivo = quitarGuionFechaHora(ordenFormatoArchivo, 'H');
                    nombreFinal = replaceFechaHoraNombreArchivo(ordenFormatoArchivo, stateArchivoAsociado);
                    break;
                case 4:
                    ordenFormatoArchivo = quitarGuionFechaHora(ordenFormatoArchivo, 'F');
                    nombreFinal = replaceFechaHoraNombreArchivo(ordenFormatoArchivo, stateArchivoAsociado);
                    break;
                default:
                    break;
            }
        } else {            
            nombreFinal = stateArchivoAsociado.idRBFormato ? nombreFinal : replaceFechaHoraNombreArchivo(ordenFormatoArchivo, stateArchivoAsociado);

            if(stateArchivoAsociado.idRBFormato == 1) 
                nombreFinal = replaceFechaHoraNombreArchivo(ordenFormatoArchivo, stateArchivoAsociado);
            if(stateArchivoAsociado.idRBFormato == 2)
                nombreFinal = replaceFechaHoraNombreArchivo(ordenFormatoArchivo, stateArchivoAsociado, true);
            if(stateArchivoAsociado.idRBFormato == 3) {
                ordenFormatoArchivo = quitarGuionFechaHora(ordenFormatoArchivo, 'H');
                nombreFinal = replaceFechaHoraNombreArchivo(ordenFormatoArchivo, stateArchivoAsociado);
            }
            if(stateArchivoAsociado.idRBFormato == 4) {
                ordenFormatoArchivo = quitarGuionFechaHora(ordenFormatoArchivo, 'F');
                nombreFinal = replaceFechaHoraNombreArchivo(ordenFormatoArchivo, stateArchivoAsociado);
            }
        }

        let data = {
            ArchivoAsociado: stateArchivoAsociado.nombreArchivoUsuario,
            FormatoFechaArchivoId: stateArchivoAsociado.optionSeleccionadaFecha && stateArchivoAsociado.optionSeleccionadaFecha > 0 ? parseInt(stateArchivoAsociado.optionSeleccionadaFecha) : null,
            FormatoHoraArchivoId: stateArchivoAsociado.optionSeleccionadaHora && stateArchivoAsociado.optionSeleccionadaHora > 0 ? parseInt(stateArchivoAsociado.optionSeleccionadaHora) : null,
            FormatoNombreArchivoId: stateArchivoAsociado.formatoOrdenArchivoCombo && stateArchivoAsociado.formatoOrdenArchivoCombo > 0 ? parseInt(stateArchivoAsociado.formatoOrdenArchivoCombo) : null,
            TipoSeparacionArchivo: stateArchivoAsociado.idRBFormato
        }

        _dispatch({ type: SET_VARIABLES_NOMBRE_ARCHIVO_FINAL, dataNombreArchivo: data});
    }
    _dispatch({ type: SET_NOMBRE_ARCHIVO_FINAL, valor: nombreFinal });
}


function quitarGuionFechaHora(ordenFormatoArchivo, fechaHora) {
    let posicionFechaHora, nombreFinal = "";

    if (fechaHora == 'F') {
        posicionFechaHora = ordenFormatoArchivo.indexOf('Fecha');

        if (ordenFormatoArchivo.indexOf('Fecha') < ordenFormatoArchivo.indexOf('NombreArchivo')) {
            //Fecha _ Hora_NombreArchivo
            //Hora_Fecha _ NombreArchivo
            //Fecha _ NombreArchivo_Hora
            //El formato de archivo con Fecha tiene la fecha antes que "NombreArchivo", por lo tanto quito el "_" que tiene adelante
            if (posicionFechaHora == 0) {
                nombreFinal = ordenFormatoArchivo.substr(posicionFechaHora, 5) + ordenFormatoArchivo.substr(6, ordenFormatoArchivo.length)
            } else {
                nombreFinal = ordenFormatoArchivo.substr(0, posicionFechaHora + 5) + ordenFormatoArchivo.substr(posicionFechaHora + 6, ordenFormatoArchivo.length)
            }
        } else {
            //NombreArchivo _ Fecha_Hora
            //NombreArchivo_Hora _ Fecha
            //Hora_NombreArchivo _ Fecha
            //El formato de archivo con Fecha tiene la fecha después que "NombreArchivo", por lo tanto quito el "_" que tiene detrás
            nombreFinal = ordenFormatoArchivo.substr(0, posicionFechaHora - 1) + ordenFormatoArchivo.substr(posicionFechaHora, ordenFormatoArchivo.length)
        }
    } else {
        posicionFechaHora = ordenFormatoArchivo.indexOf('Hora');

        if (ordenFormatoArchivo.indexOf('Hora') < ordenFormatoArchivo.indexOf('NombreArchivo')) {
            //Fecha_Hora _ NombreArchivo
            //Hora _ NombreArchivo_Fecha
            //Hora _ Fecha_NombreArchivo
            //El formato de archivo con Fecha tiene la fecha antes que "NombreArchivo", por lo tanto quito el "_" que tiene adelante
            if (posicionFechaHora == 0) {
                nombreFinal = ordenFormatoArchivo.substr(posicionFechaHora, 4) + ordenFormatoArchivo.substr(5, ordenFormatoArchivo.length)
            } else {
                nombreFinal = ordenFormatoArchivo.substr(0, posicionFechaHora + 4) + ordenFormatoArchivo.substr(posicionFechaHora + 5, ordenFormatoArchivo.length)
            }
        } else {
            //NombreArchivo_Fecha _ Hora
            //NombreArchivo _ Hora_Fecha
            //Fecha_NombreArchivo _ Hora
            
            //El formato de archivo con Fecha tiene la fecha después que "NombreArchivo", por lo tanto quito el "_" que tiene detrás
            nombreFinal = ordenFormatoArchivo.substr(0, posicionFechaHora - 1) + ordenFormatoArchivo.substr(posicionFechaHora, ordenFormatoArchivo.length)
        }
    }

    return nombreFinal;
}

function replaceFechaHoraNombreArchivo(ordenFormatoArchivo, stateArchivoAsociado, sinGuiones) {
    let nombreFinalAux = "";

    ordenFormatoArchivo = sinGuiones ? ordenFormatoArchivo.replace("_", "").replace("_", "") : ordenFormatoArchivo;

    if (ordenFormatoArchivo.includes("Fecha") && ordenFormatoArchivo.includes("Hora")) {
        nombreFinalAux = ordenFormatoArchivo.replace("Fecha", stateArchivoAsociado.descFormatoFechaUsuario)
            .replace("Hora", stateArchivoAsociado.descFormatoHoraUsuario).replace("NombreArchivo", stateArchivoAsociado.nombreArchivoUsuario);
    } else if (ordenFormatoArchivo.includes("Fecha")) {
        nombreFinalAux = ordenFormatoArchivo.replace("Fecha", stateArchivoAsociado.descFormatoFechaUsuario)
            .replace("NombreArchivo", stateArchivoAsociado.nombreArchivoUsuario);
    } else if (ordenFormatoArchivo.includes("Hora")) {
        nombreFinalAux = ordenFormatoArchivo.replace("Hora", stateArchivoAsociado.descFormatoHoraUsuario)
            .replace("NombreArchivo", stateArchivoAsociado.nombreArchivoUsuario);
    }

    return ordenFormatoArchivo ? nombreFinalAux : stateArchivoAsociado.nombreArchivoUsuario;
}

function setComboNombreArchivo(formatoFechaActivo, formatoHoraActivo, formatoOrdenNombreArchivo) {
    let optionNombreArchivo;

    // formatoOrdenNombreArchivo.Recordset0.Rows = Trae formato con fecha y hora
    // formatoOrdenNombreArchivo.Recordset1.Rows = Trae formato con fecha
    // formatoOrdenNombreArchivo.Recordset2.Rows = Trae formato con hora

    if (formatoFechaActivo && formatoHoraActivo)
        optionNombreArchivo = formatoOrdenNombreArchivo.Recordset0.Rows;
    else if (formatoFechaActivo && !formatoHoraActivo)
        optionNombreArchivo = formatoOrdenNombreArchivo.Recordset1.Rows;
    else if (!formatoFechaActivo && formatoHoraActivo)
        optionNombreArchivo = formatoOrdenNombreArchivo.Recordset2.Rows;

    return optionNombreArchivo;
}

function setLabelNombreArchivo(formatoFechaActivo, formatoHoraActivo) {
    let labelNombreArchivo = "";

    if (formatoFechaActivo && formatoHoraActivo)
        labelNombreArchivo = "Seleccione orden de la fecha y la hora en el nombre";
    else if (formatoFechaActivo && !formatoHoraActivo)
        labelNombreArchivo = "Seleccione orden de la fecha en el nombre";
    else if (!formatoFechaActivo && formatoHoraActivo)
        labelNombreArchivo = "Seleccione orden de la hora en el nombre";

    return labelNombreArchivo;
}

function _loadCarterasData(data) {
    LogHelper.In(_loadCarterasData.name, data);

    let result = {
        carteras: JSON.parse(data.GET_CARTERAS).Recordset0.Rows,
    };

    _dispatch({ type: GET_DATOS_CARTERAS, result: result });
}

/**
 * Funcion encargada del ruteo.
 * @param {any} params
 * @param {any} option
 * @param {any} dispatch
 */
function _routing(params, option, dispatch) {
    LogHelper.In(_routing.name, params, option, dispatch);

    if (params) {
        params = JSON.stringify(params);
    }

    const redirectLocation = ProcessManager.GetNextStep('EditarConfiguracionProcesos', option, params);

    dispatch({ type: ROUTE_TO_EDITAR_CONFIGURACION_PROCESO, data: redirectLocation });
}

function _loadValidateAddProcess(data, form) {
    LogHelper.In(_loadValidateAddProcess.name, data, form);
    let fieldsToValidate;
    const valids = [];

    fieldsToValidate = [
        { type: 'ProcesamientoParcial', valid: 'seleccionoPorcesamientoParcial' },
        { type: 'PlazoMaximo', valid: 'seleccionoPlazoMaximo' },
        { type: 'PeriodicidadSemanal', valid: 'seleccionoDiaSemana' },
        { type: 'PeriodicidadCierre', valid: 'seleccionoCierre' },
        { type: 'PeriodicidadMensual', valid: 'seleccionoDiaMensual' },
        { type: 'PeriodicidadEntreDias', valid: 'seleccionoEntreDias' },
    ];

    fieldsToValidate.forEach((f) => {
        let result = true;

        switch (f.type) {
            case 'ProcesamientoParcial':
                {
                    if (data.proceso.ProcesamientoParcial) {
                        if (data.proceso.LimiteRechazos == null || data.proceso.LimiteRechazos == '' || data.proceso.LimiteRechazos == 0) {
                            result = false;
                        }
                    }
                }
                break;

            case 'PlazoMaximo':
                {
                    if (data.proceso.ProcesamientoParcial) {
                        if (data.proceso.CantidadDiasHabilesReproceso == null || data.proceso.CantidadDiasHabilesReproceso == '' || data.proceso.CantidadDiasHabilesReproceso == 0) {
                            result = false;
                        }
                    }
                }
                break;

            case 'PeriodicidadSemanal':
                {
                    if (data.proceso.Periodicidad == 'Semanal') {
                        result = false;
                        Object.entries(data.calendario).forEach(([key, value]) => {
                            if (key != 'DiaHabil' && value === true) {
                                result = true;
                                console.log(key);
                            }
                        });
                    }
                }
                break;

            case 'PeriodicidadMensual':
                {
                    if (data.proceso.Periodicidad == 'Mensual') {
                        result = data.calendario.DiaMes >= 1 && data.calendario.DiaMes <= 31;
                    }
                }
                break;

            case 'PeriodicidadCierre':
                {
                    if (data.proceso.Periodicidad == 'Cierre') {
                        result = data.DiasRespectoAlCierre > 0;
                        if (data.calendario.CarteraId == null || data.calendario.CarteraId == 0) {
                            result = false;
                        }
                    }
                }
                break;

            case 'PeriodicidadEntreDias':
                {
                    if (data.proceso.Periodicidad == 'EntreDias') {
                        let diaInicio = data.calendario.DiaInicio >= 1 && data.calendario.DiaInicio <= 31;
                        let diaFin = data.calendario.DiaFin >= 1 && data.calendario.DiaFin <= 31 && parseInt(data.calendario.DiaFin) >= parseInt(data.calendario.DiaInicio);
                        if (!diaInicio || !diaFin) result = false;
                    }
                }
                break;

            default:
                return result;
        }

        data.ERROR_PROCESS[f.valid] = result;
        valids.push(result);
    });

    let validate = !valids.some((v) => v == false);

    if (!validate) {
        _dispatch({ type: VALIDATE_PROCESS, error: data.ERROR_PROCESS });
    } else {
        mapearDatos(data, data.proceso.Periodicidad);
        ConfiguracionProcesosManager.GuardarProceso(data, SagasHelper.GetSagasId, ejecutarPorEstado);
        _dispatch({ type: READY_REQUEST_PROCESS });
    }
}

function mapearDatos(data, clave) {
    if (data.proceso.Periodicidad == 'Cierre') {
        if (!data.esDiaPositivo) {
            data.calendario.DiaDesdeCierre = Math.abs(data.DiasRespectoAlCierre);
            data.calendario.DiaDesdeCierre = ~data.calendario.DiaDesdeCierre + 1;
        } else {
            data.calendario.DiaDesdeCierre = Math.abs(data.DiasRespectoAlCierre);
        }
    }

    data.listPeriodicidad.forEach((obj, value) => {
        if (obj.key == clave) {
            data.proceso.Periodicidad = obj.value;
        }
    });

    //seteamos el valor de proceso en calendario
    data.calendario.Activo = data.proceso.EstaActivo;
}

/**
 *
 * @param {any} result
 * @param {any} disconectCallback
 */
function ejecutarPorEstado(result, disconectCallback) {
    LogHelper.In(ejecutarPorEstado.name, result, disconectCallback);

    let modalId;

    switch (result.Estado) {
        case 2:
            modalId = 'completada';
            break;
        case 3:
            modalId = 'error';
            break;
        case 4:
            modalId = 'completadaConDependencias';
            break;
        case 5:
            modalId = 'error';
            break;
    }
    $('#' + modalId).modal();
    _dispatch({ type: SHOW_SAVE_STATUS_PROCESO, sagaId: result.SagaId, modalId: modalId });
    disconectCallback();
}